import { defineMessages } from 'react-intl';

export default defineMessages({
  quantityString: {
    id: 'quantityCapital',
    description: 'quantity',
    defaultMessage: 'Quantity',
  },
  modelString: {
    id: 'model',
    description: 'model',
    defaultMessage: 'Model',
  },
  optionClusterString: {
    id: 'optionCluster',
    description: 'option cluster',
    defaultMessage: 'Option Cluster',
  },
  totalPriceString: {
    id: 'template.totalPrice',
    description: 'total price',
    defaultMessage: 'Total Price',
  },
  priorityString: {
    id: 'template.priority',
    description: 'priority',
    defaultMessage: 'Priority',
  },
  exteriorString: {
    id: 'exteriorName',
    description: 'exterior',
    defaultMessage: 'Exterior',
  },
  wheelString: {
    id: 'wheelName',
    description: 'wheel',
    defaultMessage: 'Wheels',
  },
  interiorString: {
    id: 'interiorName',
    description: 'interior',
    defaultMessage: 'Interior',
  },
  trimString: {
    id: 'trimName',
    description: 'trim',
    defaultMessage: 'Trim',
  },
  colorLineString: {
    id: 'colorLineName',
    description: 'color line',
    defaultMessage: 'Color Line',
  },
  capsString: {
    id: 'capsName',
    description: 'caps',
    defaultMessage: 'Caps',
  },
  selectAllString: {
    id: 'selectAll',
    description: 'select all',
    defaultMessage: 'Select All',
  },
});
